var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Calendar',{staticClass:"calendar",attrs:{"language":"fr","display-week-number":true,"data-source":_vm.weeksSelect,"render-style":"background","id":"calendar"},on:{"click-day":_vm.selectDay}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }